import { makeRequest } from 'utils/requestLogger';

export default (id) => makeRequest('get', `/api/recaps/roundtable/${id}`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/recap/getRecapByRoundtableId.js